import styled from "styled-components";
import {BasicPageWrapper} from "../../Theme/basicElements";

export const OrdersPageWrapper = styled(BasicPageWrapper)`
  height: calc(100vh - 100px);
`;